import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const LaptopCooler = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M2.668 2.322h10.666a2.002 2.002 0 0 1 2 2v8.666a2.002 2.002 0 0 1-2 2H2.668a2.002 2.002 0 0 1-2-2V4.322a2.002 2.002 0 0 1 2-2Zm10.666 12a1.334 1.334 0 0 0 1.334-1.333V4.322a1.333 1.333 0 0 0-1.334-1.333H2.668a1.333 1.333 0 0 0-1.333 1.333v8.666a1.333 1.333 0 0 0 1.333 1.334h10.666Z" />
      <path d="M8.804 9.127a.333.333 0 0 1-.261-.54c.311-.396.48-.885.478-1.389a2.356 2.356 0 0 0-.833-1.761V8.3a.333.333 0 0 1-.667 0V4.287l.481.237A3.022 3.022 0 0 1 9.688 7.19v.004A2.905 2.905 0 0 1 9.066 9a.333.333 0 0 1-.262.126ZM3.541 12.334l-.036-.533A3.022 3.022 0 0 1 4.97 9.007l.003-.002a2.906 2.906 0 0 1 1.876-.364.333.333 0 1 1-.096.66 2.236 2.236 0 0 0-1.442.28 2.356 2.356 0 0 0-1.107 1.601L6.684 9.75a.333.333 0 1 1 .333.578L3.54 12.334ZM10.375 12.563a3.02 3.02 0 0 1-1.473-.383H8.9a2.906 2.906 0 0 1-1.253-1.442.333.333 0 0 1 .62-.247c.186.468.526.859.962 1.11a2.357 2.357 0 0 0 1.943.158l-2.479-1.433a.333.333 0 1 1 .333-.577l3.475 2.006-.445.298a3.021 3.021 0 0 1-1.68.51Z" />
      <path d="M7.854 7.967a1.492 1.492 0 1 1 0 2.985 1.492 1.492 0 0 1 0-2.985Zm0 2.318a.826.826 0 1 0 0-1.651.826.826 0 0 0 0 1.651Z" />
    </svg>
  );
};

LaptopCooler.category = 'product-category';

LaptopCooler.displayName = 'LaptopCooler';
